/* user modules */
angular.module('bmsApp.marketing', ['ui.router'])
	.config(['$stateProvider', '$urlRouterProvider', 'BMSPermission', function config($stateProvider, $urlRouterProvider, BMSPermission) {
			$stateProvider

				.state('main.marketing', {
					url: '/marketing',
					abstract: true,
					views: {
						'main@main': {
							templateUrl: 'ng/marketing/templates/marketingMain.html',
							controller: 'MarketingMainCtrl'
						},
					},
					data: {authorisedRoles: [BMSPermission.MARKETING]},
				})


				// Campaigns -----------------------------------------------------------------------------------
				.state('main.marketing.campaignIndex', {
					url: '/campaigns',
					views: {
						'content@main.marketing': {
							templateUrl: "ng/marketing/campaign/templates/CampaignIndex.html",
							controller: 'CampaignIndexCtrl'
						},
						'side-content@main.marketing': {
							templateUrl: 'ng/marketing/campaign/templates/sideContent.html'
						}
					},
					ncyBreadcrumb: {label: 'Campaigns'}
				})

				.state('main.marketing.remoteCampaignIndex', {
					url: '/remote-campaigns',
					views: {
						'content@main.marketing': {
							templateUrl: "ng/marketing/campaign/templates/RemoteCampaignIndex.html",
							controller: 'RemoteCampaignIndexCtrl'
						},
						'side-content@main.marketing': {
							templateUrl: 'ng/marketing/campaign/templates/sideContent.html'
						}
					},
					ncyBreadcrumb: {label: 'Remote Campaigns'}
				})

				.state('main.marketing.remoteCampaignIndex.overview', {
					url: '^/remote-campaigns/overview/:schemeId',
					views: {
						'content@main.marketing': {
							templateUrl: "ng/marketing/scheme/templates/MarketingSchemeOverview.html",
							controller: 'MarketingSchemeOverviewCtrl',
							controllerAs: 'MarketingScheme',
						},
						'side-content@main.marketing': {
							templateUrl: null
						}

					},
					ncyBreadcrumb: {label: '{{ scheme.name }}'}
				})

				.state('main.marketing.campaignIndex.campaignCreate', {
					url: '^/marketing/campaign/create',
					views: {
						'content@main.marketing': {
							templateUrl: "ng/marketing/campaign/templates/CampaignSave.html",
							controller: 'CampaignSaveCtrl'
						},
						'side-content@main.marketing': {
							templateUrl: null
						}
					},
					ncyBreadcrumb: {label: 'New Campaign'}
				})

				.state('main.marketing.campaignIndex.campaignUpdate', {
					url: '^/marketing/campaign/edit/:campaignId',
					views: {
						'content@main.marketing': {
							templateUrl: "ng/marketing/campaign/templates/CampaignSave.html",
							controller: 'CampaignSaveCtrl'
						},
						'side-content@main.marketing': {
							templateUrl: null
						}

					},
					ncyBreadcrumb: {label: 'Edit'}
				})

				.state('main.marketing.campaignIndex.campaignOverview', {
					url: '^/marketing/campaign/overview/:campaignId',
					views: {
						'content@main.marketing': {
							templateUrl: "ng/marketing/campaign/templates/CampaignOverview.html",
							controller: 'CampaignOverviewCtrl'
						},
						'side-content@main.marketing': {
							templateUrl: null
						}

					},
					ncyBreadcrumb: {label: '{{ campaign.name }}'}
				})



				.state('main.marketing.campaignIndex.campaignOverview.initiativeCreate', {
					url: '^/marketing/initiative/create/:campaignId',
					views: {
						'content@main.marketing': {
							templateUrl: "ng/marketing/initiative/templates/InitiativeSave.html",
							controller: 'InitiativeSaveCtrl'
						},
						'side-content@main.marketing': {
							templateUrl: null
						}

					},
					ncyBreadcrumb: {label: 'Add Initiative '}
				})

				.state('main.marketing.campaignIndex.initiativeCreate', {
					url: '^/marketing/initiative/create',
					views: {
						'content@main.marketing': {
							templateUrl: "ng/marketing/initiative/templates/InitiativeSave.html",
							controller: 'InitiativeSaveCtrl'
						},
						'side-content@main.marketing': {
							templateUrl: null
						}

					},
					ncyBreadcrumb: {label: 'Add Initiative '}
				})

				.state('main.marketing.campaignIndex.campaignOverview.initiativeUpdate', {
					url: '^/marketing/initiative/update/:initiativeId',
					views: {
						'content@main.marketing': {
							templateUrl: "ng/marketing/initiative/templates/InitiativeSave.html",
							controller: 'InitiativeSaveCtrl'
						},
						'side-content@main.marketing': {
							templateUrl: null
						}

					},
					ncyBreadcrumb: {label: 'Edit Initiative '}
				})


				// Customer Groups --------------------------------------------------------------------------
				.state('main.marketing.customerGroupIndex', {
					url: '/advertising-groups',
					views: {
						'content@main.marketing': {
							templateUrl: "ng/marketing/customerGroup/templates/CustomerGroupIndex.html",
							controller: 'CustomerGroupIndexCtrl'
						},
						'side-content@main.marketing': {
							templateUrl: 'ng/marketing/customerGroup/templates/SideContent.html'
						}
					},
					ncyBreadcrumb: {label: 'Advertising Groups'}
				})

				.state('main.marketing.customerGroupIndex.map', {
					url: '/advertising-group/map/:id',
					views: {
                        'main@main': {
                            templateUrl: "ng/crm/customer/templates/CustomerMap.html",
                            controller: 'CustomerMapCtrl'
                        }
					},
					ncyBreadcrumb: {label: 'Customers in group: {{ customerGroup.customer_group }}'}
				})


				.state('main.marketing.customerGroupIndex.customerGroupEdit', {
					url: '^/marketing/advertising-group/edit/:id',
					views: {
						'content@main.marketing': {
							templateUrl: "ng/marketing/customerGroup/templates/CustomerGroupSave.html",
							controller: 'CustomerGroupSaveCtrl'
						},
						'side-content@main.marketing': {
							templateUrl: null
						}
					},
					ncyBreadcrumb: {label: 'Edit {{ customerGroup.customer_group }}'}

				})



				.state('main.marketing.customerGroupIndex.customerGroupCreate', {
					url: '^/marketing/advertising-group/add',
					views: {
						'content@main.marketing': {
							templateUrl: "ng/marketing/customerGroup/templates/CustomerGroupSave.html",
							controller: 'CustomerGroupSaveCtrl'
						},
						'side-content@main.marketing': {
							templateUrl: null
						}
					},
					ncyBreadcrumb: {label: 'New Advertising Group'}
				})


                // Mailchimp
				.state('main.marketing.mailchimp', {
					url: '^/marketing/mailchimp/send/:id',
					views: {
						'content@main.marketing': {
							templateUrl: "ng/marketing/mailchimp/templates/MailchimpSend.html",
							controller: 'MailchimpCtrl'
						},
						'side-content@main.marketing': {
							templateUrl: null
						}
					},
					ncyBreadcrumb: {label: 'Send Campaign'}

				})

		}]);



